/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "F:/zhaoyanning/mobile-v2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "F:/zhaoyanning/mobile-v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Scroll from '@/components/Scroll/Scroll';
import Tab from 'vux/src/components/tab/tab';
import TabItem from 'vux/src/components/tab/tab-item';
export default {
  name: 'MyMeetingOrder',
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Scroll: Scroll
  },
  data: function data() {
    return {
      timestamp: 0,
      //当前时间的时间戳
      eventList: [],
      //活动/事件数组
      meetingType: this.$utils.Store.getItem('meetingType') ? this.$utils.Store.getItem('meetingType') : 0,
      //0:未开始;2:已结束;不传为全部;
      tabData: [{
        title: '我申请的'
      }, {
        title: '我审批的'
      }, {
        title: '我参与的'
      }],
      active: this.$utils.Store.getItem('curActive') ? +this.$utils.Store.getItem('curActive') : 0,
      meetingList: [],
      //meetingState--0：已结束；1：进行中；2：已预约
      curMonth: '',
      //当前年月
      emptyShow: false,
      emptyTip: '暂无会议预约',
      pullDownRefresh: {
        threshold: 40,
        // 下拉多少开始刷新
        stop: 20 // 下拉回弹到多少停住

      },
      pullUpLoad: {
        threshold: 25
      },
      isPullDown: false,
      // 正在下拉刷新
      isPullUp: false,
      // 正在上拉加载
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0
    };
  },
  computed: {},
  methods: {
    // 下拉
    onPullingDown: function onPullingDown() {
      if (this.isPullDown) return;
      this.isPullDown = true; // 下拉刷新

      this.meetingList = [];
      this.pageIndex = 1;
      this.getInfoList();
    },
    // 上划
    onPullingUp: function onPullingUp() {
      this.pageIndex = this.pageIndex + 1;

      if (this.pageIndex > this.totalPage) {
        this.updateScroll();
        return;
      }

      if (this.isPullUp) return;
      this.isPullUp = true;
      this.getInfoList();
    },
    //刷新
    updateScroll: function updateScroll(flag) {
      this.isPullDown = false;
      this.isPullUp = false;
      this.$refs.scroll.forceUpdate(flag);
    },
    // 获取当前日期
    getSysDate: function getSysDate() {
      var _this = this;

      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          _this.currDate = data.sysDate.substring(0, 10);
          _this.timestamp = _this.$utils.DateUtils.getTimeStamp(data.sysDate) * 1000;

          _this.getInfoList();
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    getInfoList: function () {
      var _getInfoList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _response, code, msg, data, _this$meetingList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$utils.Tools.loadShow();
                this.emptyShow = false;
                params = {
                  pageIndex: this.pageIndex,
                  pageSize: this.pageSize,
                  search: {
                    userSerial: this.$utils.Store.getItem('userSerial')
                  }
                };

                if (!(this.active === 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this.$api.Meeting.selectMySubmit(params);

              case 6:
                response = _context.sent;
                _context.next = 18;
                break;

              case 9:
                if (!(this.active === 1)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return this.$api.Meeting.selectMyApprove(params);

              case 12:
                response = _context.sent;
                _context.next = 18;
                break;

              case 15:
                _context.next = 17;
                return this.$api.Meeting.selectMyCopy(params);

              case 17:
                response = _context.sent;

              case 18:
                this.$utils.Tools.loadHide();
                _response = response, code = _response.code, msg = _response.msg, data = _response.data;

                if (+code !== this.$code.success) {
                  this.$utils.Tools.toastShow(msg);
                  this.updateScroll(false);
                } else {
                  (_this$meetingList = this.meetingList).push.apply(_this$meetingList, _toConsumableArray(data.records));

                  this.pageIndex = data.pageIndex;
                  this.totalPage = data.totalPage;

                  if (this.meetingList.length === 0) {
                    this.emptyShow = true;
                  }

                  this.updateScroll(false);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfoList() {
        return _getInfoList.apply(this, arguments);
      }

      return getInfoList;
    }(),
    // 点击获取当前日期下的已预约或者已结束的会议列表
    onItemClick: function onItemClick(index) {
      this.pageIndex = 1;
      this.active = index;
      this.$utils.Store.setItem('curActive', this.active);
      this.meetingList = [];
      this.getInfoList();
    },
    // 点击tab
    itemClick: function itemClick(value) {
      // 点击我申请的
      if (this.active == 0) this.$router.push({
        name: '我申请的',
        query: {
          id: value.approveState,
          bh: value.bh
        }
      });else if (this.active == 1) // 点击我审批的
        this.$router.push({
          name: '我审批的',
          query: {
            id: value.approveState,
            bh: value.bh
          }
        }); //  点击其他(我参与的)
      else this.$router.push({
        name: 'MeetingDetail',
        query: {
          bh: value.bh
        }
      });
    }
  },
  created: function created() {
    this.$utils.Store.setItem('curActive', '0');
    this.getSysDate();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
};